import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { BiLoaderAlt } from "react-icons/bi";
import PostBlockPreview from "../Modals/post-blocks-preview";
import History from "../../stores/services/history";
import { updateSetting } from "../../stores/actions/settings.actions.types";
import { connect } from "react-redux";
import EmailFooterCreate from "./AddEmailFooterBlock";

const isValidUrl = (url) => /^https?:\/\/[^\s$.?#].[^\s]*$/gm.test(url);

const isValidImageUrl = (url) =>
  /^https?:\/\/.+\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i.test(url);

const validationSchema = Yup.object({
  footerBlocks: Yup.array().of(
    Yup.object().shape({
      type: Yup.string().required("Block type is required"),
      value: Yup.string()
        .test("conditional-validation", function (value) {
          const { type, isUploadMode } = this.parent;

          if (type === "hr") return true;

          if (type === "link") {
            if (!value) return this.createError({ message: "URL is required" });
            if (!isValidUrl(value)) {
              return this.createError({ message: "Please enter a valid URL" });
            }
            return true;
          }

          if (type === "image" && isUploadMode === false) {
            if (!value) {
              return this.createError({ message: "Image URL is required" });
            }
            if (!isValidImageUrl(value)) {
              return this.createError({
                message:
                  "Please enter a valid image URL (jpg, jpeg, png, gif, webp)",
              });
            }
            return true;
          }

          return true;
        })
        .nullable(),
    })
  ),
});

const AddEmailFooterForm = ({ setting, updateSetting }) => {
  const [footerLoading, setFooterLoading] = useState(false);
  const [previewBlock, setPreviewBlock] = useState({});

  const [opened, setOpend] = useState(false);
  const handlePreview = (values) => {
    setPreviewBlock(values);
    setOpend(true);
  };

  const handleSubmit = (values, { resetForm }) => {
    setFooterLoading(true);

    const callback = (data) => {
      setFooterLoading(false);
      if (data.success) {
        resetForm();
        History.push("/settings/email-settings");
      }
    };

    updateSetting({
      data: values,
      callback,
    });
  };

  return (
    <div className='rounded-[10px] border border-stroke bg-white p-4 shadow-1 dark:border-dark-3 dark:bg-boxdark dark:shadow-card sm:p-7.5'>
      <Formik
        initialValues={setting}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values }) => (
          <Form className='mg:p-6 mx-auto space-y-4 rounded-md p-2'>
            <div className='grid grid-cols-1 gap-4'>
              <EmailFooterCreate
                values={values}
                setFieldValue={setFieldValue}
              />
            </div>

            <div className='flex sm:flex-row flex-col gap-10'>
              <button
                type='submit'
                disabled={footerLoading}
                className='w-full bg-red-600 text-white py-2 rounded-md'
              >
                {footerLoading ? (
                  <BiLoaderAlt className='animate-spin text-2xl m-auto  text-white' />
                ) : (
                  "Update Footer"
                )}
              </button>
              <button
                type='button'
                onClick={() => handlePreview(values)}
                className='w-full  bg-red-600 text-white py-2 rounded-md'
              >
                Preview
              </button>
            </div>
          </Form>
        )}
      </Formik>

      <PostBlockPreview
        block={{ blocks: previewBlock?.footerBlocks }}
        opened={opened}
        setOpend={setOpend}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });
export default connect(mapStateToProps, { updateSetting })(AddEmailFooterForm);
